<template>
  <div class="cartpage">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <CommonHead></CommonHead>
    <!-- Save to projects pop up -->
    <b-modal
      id="saveto-project"
      ref="popupmodal"
      title="Save to Projects"
      title-tag="h3"
      ok-only
      modal-class="common_pop saveto_project"
    >
      <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
        <h3>Save to Projects</h3>
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="showclient = !showclient"
            >Existing Client - Existing Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewproject = !shownewproject"
            >Existing Client - New Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewclient = !shownewclient"
            >New Client- New Project</a>
          </li>
        </ul>
      </div>
      <div v-if="showclient" class="savetoclient">
        <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to Existing Client- Project</h3>
        <b-form class="commonform" ref="form1" @submit="Submit1Popup">
          <div class="row">
            <div
              class="col"
              :state="!form1.errors.has('client')"
              :class="form1.errors.get('client')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('client')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('client')"
                  @input="form1.errors.clear('client'); getProjects();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form1.client"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject">
            <div
              class="col"
              :state="!form1.errors.has('project')"
              :class="form1.errors.get('project')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('project')"
            >
              <label class="setuplabel">Select a Project</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('project')"
                  @input="form1.errors.clear('project')"
                  :options="projects"
                  :reduce="projects => projects.value"
                  label="text"
                  v-model="form1.project"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
              </div>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
		  <span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewproject" class="savetoclient">
        <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Project of Existing Client</h3>
        <b-form class="commonform" ref="form2" @submit="Submit2Popup">
          <div class="row">
            <div
              class="col"
              :state="!form2.errors.has('client_id')"
              :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
              :invalid-feedback="form2.errors.get('client_id')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form2.errors.has('client_id')"
                  @input="form2.errors.clear('client_id'); showProject1();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form2.client_id"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject1">
            <div class="col">
              <md-field
                :state="!form2.errors.has('name')"
                :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                :invalid-feedback="form2.errors.get('name')"
              >
                <label class="setuplabel">Create and save to new project</label>
                <md-input
                  :state="!form2.errors.has('name')"
                  @input="form2.errors.clear('name')"
                  v-model="form2.name"
                ></md-input>

                <span
                  class="error-msg"
                  v-if="form2.errors.get('name')"
                >{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
              </md-field>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
		  <span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewclient" class="savetoclient newcreation">
        <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Client- Project</h3>
        <b-form class="commonform" ref="form" @submit="Submit3Popup">
          <md-field
            :state="!form.errors.has('createclient')"
            :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
            :invalid-feedback="form.errors.get('createclient')"
          >
            <label>Create a new client</label>
            <md-input
              :state="!form.errors.has('createclient')"
              @input="form.errors.clear('createclient'); showProject2();"
              v-model="form.createclient"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createclient')"
            >{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
          </md-field>
          <md-field
            :state="!form.errors.has('createproject')"
            :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
            :invalid-feedback="form.errors.get('createproject')"
          >
            <label>Create a new project</label>
            <md-input
              :state="!form.errors.has('createproject')"
              @input="form.errors.clear('createproject')"
              v-model="form.createproject"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createproject')"
            >{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
          </md-field>
          <b-button block type="submit" variant="dark">Add</b-button>
		  <span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
        </b-form>
      </div>
    </b-modal>
    <!-- Delete Product Pop Up -->
    <b-modal
      id="delete-productcart"
      ref="modal"
      title="Are you sure you want to delete this product?"
      title-tag="h3"
      ok-only
      modal-class="common_pop delete_productcart"
    >
      <b-row>
        <b-col cols="7">
          <b-button @click="removeItem(itemToDelete)" type="submit" block variant="dark">Delete</b-button>
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal" block variant="outline-primary" squared>Cancel</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <div class="basestyle-backdrop bg-dark" v-if="basestyleshow == true" @click="closeBaseFabrics"></div>
    <div class="basestylecontainer" v-if="basestyleshow == true">
      <div class="row my-5">
        <h3 class="mx-auto pl-65 basecotainertitle">Select a Base</h3>
        <b-img
          class="mr-5 basestylecontainer-close-icon"
          src="/shop/images/close.svg"
          fluid
          alt="close image"
          @click="closeBaseFabrics"
        ></b-img>
      </div>
      <perfect-scrollbar :suppressScrollX="false">
        <SKLoader :repeat="5" :loading="isLoadingBase" speed="1s" class="baseloadercont">
          <SKBaseFabrics/>
        </SKLoader>
        <template v-if="baseFabrics.length > 0 && isLoadingBase == false">
          <template>
            <div v-for="(baseFabric, i) in baseFabrics" class="p-3" :key="i">
              <div class="row mb-5">
                <div class="col-5">
                  <b-img :src="baseFabric.URL" fluid></b-img>
                </div>
                <div class="col-7">
                  <h3 class="text-left mb-3 basefabricname">
                    {{ baseFabric.NAME }}
                  </h3>
                  <p>Price: 
                    <span class="font-weight-normal">
                      $ {{ parseFloat(baseFabric.AMOUNT).toFixed(2) }} / per yd
                    </span>
                  </p>
                  <p class="basefabricdescrip">{{ baseFabric.RMC_BaseFabricDesc }}</p>
                  <hr>
                  <div class="accordion">
                    <a class="text-decoration-none" href="javascript:;" v-b-toggle="'collapse-' + i">
                      Specifications
                    </a>
                    <div class="specification mt-3">
                      <div class="spec_cont">
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Width:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWidth != '' ? parseFloat(baseFabric.RMC_BaseFabricWidth).toFixed(2) : "-" }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Weight:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWeight != '' ? parseFloat(baseFabric.RMC_BaseFabricWeight).toFixed(2) : '' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Content:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricContent != '' ? baseFabric.RMC_BaseFabricContent : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Country:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.LogisticsAddressCountryRegionId != '' ? baseFabric.LogisticsAddressCountryRegionId : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Wyzenbeek:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWyzenbeek != '' ? baseFabric.RMC_BaseFabricWyzenbeek : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Martindale:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricMartindale != '' ? baseFabric.RMC_BaseFabricMartindale : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>CleaningCode:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.CleaningCode != '' ? baseFabric.CleaningCode : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Test Code:</span>
                          </div>
                          <div class="txtspec">
                            <p>
                              {{ baseFabric.rmcFireTestCode1 != '' ? baseFabric.rmcFireTestCode1 : '-' }},
                              {{ baseFabric.rmcFireTestCode2 != '' ? baseFabric.rmcFireTestCode2 : '-' }},
                              {{ baseFabric.rmcFireTestCode3 != '' ? baseFabric.rmcFireTestCode3 : '-' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn btn-outline-primary fabricSelectBtn" @click="baseFabricSelected(baseFabric)">SELECT</button>
                </div>
              </div>
              <hr>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-center">
            <h3 class="mt-5">No Fabric Found. </h3>
          </div>
        </template>
      </perfect-scrollbar>
    </div>
    <div class="topcarthide" v-if="inCartItems.ITEMS.length > 0">
      <div class="maincart">
        <div class="leftcart">
          <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
          <h1>Your Cart</h1>
          <div class="singledetails" v-for="(lc,lck) in inCartItems.ITEMS" :key="lck">
            <div class="alldetails">
              <div class="imgbox">
                <b-img :src="lc.SMALL_IMAGE" fluid alt="project image"></b-img>
              </div>
              <div class="contentbox">
                <h3>
                  <template v-if="lc.ITEMID == 'CW000'">
                    Custom Print
                  </template>
                  <template v-else-if="lc.ORDERTYPE == 'CDI'">
                    {{lc.ITEMNAME}}
                  </template>
                  <template v-else>
                    {{lc.ITEMNAME}} / {{lc.COLORNAME}}
                  </template>
                  <span class="cartprice">${{lc.TOTAL}}</span>
                </h3>
                <div class="samediv">
                  <template v-if="lc.ITEMID == 'CW000'">
                    <span>ID :</span>
                    <p>{{lc.ITEMID}}</p>
                  </template>
                  <template v-else>
                    <span>ID :</span>
                    <p>{{lc.ITEMID}}-{{lc.INVENTCOLORID}}</p>
                  </template>
                </div>
                <div class="samediv" v-if="lc.DESIGN_NAME">
                  <span>Name :</span>
                  <p>{{ lc.DESIGN_NAME }}</p>
                </div>
                <div class="samediv">
                  <span>Order type :</span>
                  <p>{{lc.ORDERTYPE}}</p>
                </div>
                <div class="samediv" v-if="lc.BASEFABRICNAME">
                  <span>Base Fabric :</span>
                  <p>{{ lc.BASEFABRICNAME }}</p>
                  <a href="javascript:;" @click="loadBaseFabrics(lc.ID,lc.ITEMID,lc.INVENTCOLORID)" class="editbaseproject" v-if="lc.ORDERTYPE == 'regular'">
                    <img src="/shop/images/edit.svg" alt="Edit" />
                  </a>
                </div>
                <div class="samediv" v-if="lc.DISCOUNTEDPRICE > 0">
                  <span>Price :</span>
                  <p class="regularprice">$ {{lc.REGULARPRICE}}</p>
                  <p class="discountamt">$ {{lc.DISCOUNTEDPRICE}}</p>
                </div>
                <div class="samediv" v-else>
                  <span>Price :</span>
                  <p>${{lc.REGULARPRICE}}</p>
                </div>
                <div class="samediv quantity" v-if="lc.ORDERTYPE != 'CDI'">
                  <span>Qty :</span>
                  <div class="qtydiv" v-if="lc.ORDERTYPE != 'memo'">
                    <span @click="decrement(lc.ID)">-</span>
                    <input :id="'qtybox_'+lc.ID" v-model.number="lc.QTY" type="number" step=".01" @change="handleInput(lc.ID)" :readonly="lc.BASEFABRICNAME && lc.PC_TYPE == 'Sample'" />
                    <span v-if="lc.STATUS == 'Discontinued' && Number(lc.QTY + 1) > Number(lc.MAXQTY)" class="lastspan">+</span>
                    <span v-else @click="increment(lc.ID)" class="lastspan">+</span>
                  </div>
                  <p v-else>{{lc.QTY}}</p>
                </div>
                <div class="samediv quantity" v-else>
                  <span>Qty :</span>
                  <div class="qtydiv">
                    <span @click="decrementCDI(lc.ID)">-</span>
                    <input :id="'qtyboxCDI_'+lc.ID" v-model.number="lc.QTY" type="number" @change="handleInputCDI(lc.ID)" />
                    <span @click="incrementCDI(lc.ID)" class="lastspan">+</span>
                  </div>
                </div>
                <div class="samediv" v-if="lc.NOTES">
                  <p class="spe_inst">{{lc.NOTES}}</p>
                </div>
                <div class="samediv" v-if="lc.STATUS == 'Discontinued' && Number(lc.QTY) > Number(lc.MAXQTY)">
                  <p class="notify_exceed">Seleted quantity is not availabile.</p>
                </div>
                <div class="savecancel">
                  <a 
                    v-if="lc.ORDERTYPE=='CDI'" 
                    @click="loadDetailsCDI(lc.CDI_ID,lck)"
                    href="javascript:;"
                    class="saveproj">
                    <b-img src="/shop/images/bookmark.svg" fluid alt="Save image"></b-img>View Details
                  </a>
                  <span v-if="(lc.PC_TYPE == 'Sample' && lc.BASEFABRICNAME) || lc.PC_TYPE == 'fauxfur'"></span>
                  <a
                    v-else
                    v-show="lc.ORDERTYPE.toLowerCase() != 'holdtendays'"
                    href="javascript:;"
                    @click="(lc.ORDERTYPE=='CDI')?showSavePromoToProject(lc.CDI_ID,lc.PC_TYPE):Showsavetoproject(lc.ID);"
                    class="saveproj"
                  >
                    <b-img src="/shop/images/bookmark.svg" fluid alt="Save image"></b-img>Save to Projects
                  </a>
                  <router-link class="editproj" v-if="lc.PC_TYPE == 'CDI' && lc.ITEMNAME.toLowerCase() == 'sheer'" :to="'/shop/sheer-by-the-inch/update/'+lc.CDI_ID+'?cart=1'"><b-img src="/shop/images/edit.svg" fluid alt="edit image"></b-img>Edit</router-link>
                  <router-link class="editproj" v-if="lc.PC_TYPE == 'CDI' && lc.ITEMNAME.toLowerCase() != 'sheer'" :to="'/shop/promo/update/'+lc.CDI_ID+'?cart=1'"><b-img src="/shop/images/edit.svg" fluid alt="edit image"></b-img>Edit</router-link>
                  <router-link class="editproj" v-if="lc.PC_TYPE == 'CDIP'" :to="'/shop/pleated-drapery/update/'+lc.CDI_ID+'?cart=1'"><b-img src="/shop/images/edit.svg" fluid alt="edit image"></b-img>Edit</router-link>
                  <router-link class="editproj" v-if="lc.PC_TYPE == 'CDIQ'" :to="'/shop/quick-ship/update/'+lc.CDI_ID+'?cart=1'"><b-img src="/shop/images/edit.svg" fluid alt="edit image"></b-img>Edit</router-link>
                  <a
                    href="javascript:;"
                    v-b-modal.delete-productcart
                    class="deleteproj"
                    @click="itemToDelete=lc.ID"
                  >
                    <b-img src="/shop/images/close.svg" fluid alt="Close image"></b-img>Remove
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightcart">
          <div class="rightinner">
            <div class="cartvalue">
              <span>Sub Total</span>
              <p>${{inCartItems.subtotal}}</p>
            </div>
            <div class="cartvalue">
              <span>Shipping</span>
              <p><span v-if="inCartItems.shipping != 'TBD'">$</span>{{inCartItems.shipping}}</p>
            </div>
            <div class="cartvalue" v-if="inCartItems.tariff > 0">
              <span>Tariff</span>
              <p>${{inCartItems.tariff}}</p>
            </div>
            <div class="cartvalue totalvalue">
              <span>Total</span>
              <p>${{inCartItems.total}}</p>
            </div>
            <b-button block variant="dark" squared @click="redirectCheckout" :disabled='isDisabled'>Proceed to checkout</b-button>
            <b-button
              v-if="(inCartItems.ITEMS[0].ORDERTYPE.toLowerCase() != 'holdtendays'  && disabledProject == false)"
              @click="ShowsavetoprojectAll();"
              block
              variant="outline-primary"
              :disabled="disabledProject == true"
            >
              <b-img class="saveproject" src="/shop/images/bookmark.svg" fluid alt="save image"></b-img>
              <b-img
                class="saveproject white"
                src="/shop/images/bookmark-white.svg"
                fluid
                alt="save image"
              ></b-img>Save all to Projects
            </b-button>
            <p
              class="cartnote mt-45"
            >*Orders entered after 3:00 PM CST may not ship until the next business day.</p>
            <p
              class="cartnote"
            >**Shipping charges are a calculated estimate and are subject to adjustment.</p>
            <div class="help_signup">
              <p>Need Help with this order?</p>
              <b-button block variant="outline-primary" squared>Contact Us</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="emptycart" v-if="isCartempty == true">
      <div class="container">
        <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
        <div class="noitems">
          <div class="roundcart">
            <b-img class="cartimg" src="/shop/images/cart-white.svg" alt="Cart White image"></b-img>
          </div>
          <h1>Your Cart is Empty !</h1>
          <ul class="shopfromcart">
            <li>
              <router-link to="/shop/products/fabric">Shop Fabrics</router-link>
              <span>|</span>
            </li>
            <li>
              <router-link to="/shop/products/trim">Shop Trims</router-link>
              <span>|</span>
            </li>
            <li>
              <a href="/hardware-brands/">Shop Hardware</a>
              <span>|</span>
            </li>
            <li>
              <router-link to="/furnishing/">Order Furnishings</router-link>
            </li>
          </ul>
          <div class="needhelp">
            <h3>Need Help?</h3>
            <div class="callwrite">
                <div class="callus">
                <h4>Call Us</h4>
                <a href="#">
                    <b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
                </a>
                <span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
                </div>
                <div class="writeus">
                <h4>Write to Us</h4>
                <a href="mailto:customerservice@rmcoco.com">
                    <b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
                </a>
                <span>We’ll get back to you within 24 hours.</span>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
    <ProjectModal ref="project" />
    <ItemDetailCDIModal ref="itemDetailCDI"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ProjectModal from "@/views/ProjectModal/ProjectModal.vue";
import ItemDetailCDIModal from "@/components/ItemDetailCDIModal.vue";
import SKBaseFabrics from "@/views/skeletons/SKBaseFabrics";

export default {
  components: {
    CommonHead,
    CommonFoot,
    ModelSelect,
    ProjectModal,
    ItemDetailCDIModal,
    SKBaseFabrics,
    "v-select": vSelect,
    Loading
  },
  computed: {
    ...mapGetters(["user", "cartproducts","isCartStateEmpty"]),
    inCartItems() {
      return this.cartproducts;
    },
    cartState(){
      if(this.isCartStateEmpty == true){
        this.isCartempty = true;
      }
      return this.isCartStateEmpty;
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch("loadCart", this.user.accountnumber).finally(() => {
        if(this.inCartItems.ITEMS.length === 0){
          this.isCartempty = true;
        }
        this.isLoading = false;
        this.isDisabledBtn();
    });
    this.LoadClients();
  },
  data() {
    return {
      itemToDelete: null,
      form: new Form({
        createclient: "",
        createproject: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
		    error_name:'',
      }),
      form1: new Form({
        client: "",
        project: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
		    error_name:'',
      }),
      form2: new Form({
        client_id: "",
        name: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
		    error_name:'',
      }),
      showclient: false,
      cart: "",
      user_id: "",
      shownewproject: false,
      shownewclient: false,
      isCartempty: false,
      isDisabled: false,
      disabledProject:false,
      isPleated: false,
      isQuickship: false,
      clientscart: [
        { value: "1", text: "James" },
        { value: "2", text: "Mathew" },
        { value: "3", text: "John" },
        { value: "4", text: "Nick" }
      ],
      projects: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
      saveprojectcart: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
      existing3cart: "",
      isLoading: false,
      isLoadingBase:false,
      breadcrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Cart",
          active: true
        }
      ],
      basestyleshow: false,
      baseFabrics: [],
      baseFabricsRegular: [],
      saveid: "",
    };
  },
  methods: {
    isDisabledBtn() {
      this.isDisabled = false;
      this.disabledProject = false;
      this.inCartItems.ITEMS.filter(lc => {
        if(lc.STATUS == "Discontinued" && lc.QTY > lc.MAXQTY){
          this.isDisabled = true;
          this.$notify({
            text: "Your selected items in the cart exceed the quantity. Kindly please update the quantity or remove the product to proceed.",
            type: "error",
            duration: 10000
          });
        }
        if(lc.PC_TYPE == 'Sample' && lc.BASEFABRICNAME){
          this.disabledProject = true;
        }
      });
    },
    loadCartItems(user_id) {
      this.isLoading = true;
      this.$store.dispatch("loadCart", user_id).finally(() => {
        if(this.inCartItems.ITEMS.length === 0){
          this.isCartempty = true;
        }
        this.isLoading = false;
        this.isDisabledBtn();
      });
    },
    removeItem(id) {
      this.hideModal();
      this.$store.dispatch("deleteCartItem", {id:id,user_id:this.user.accountnumber}).finally(() => {
        this.isLoading = true;
        this.loadCartItems(this.user.accountnumber);
      });
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    increment(id) {
      var val = document.getElementById("qtybox_" + id).value;
      val = (Number(val) + 1).toFixed(2);
      document.getElementById("qtybox_" + id).value = val;
      this.updateQty(val, id);
    },
    handleInput(id){
      var val = Number(document.getElementById("qtybox_" + id).value).toFixed(2);
      $("#qtybox_"+id).val(val);
      this.updateQty(val, id);
    },
    decrement(id) {
      var val = document.getElementById("qtybox_" + id).value;
      if (val === 1) {
        console.log("Negative quantity not allowed");
      } else {
        val = (Number(val) - 1).toFixed(2);
        document.getElementById("qtybox_" + id).value = val;
        this.updateQty(val, id);
      }
    },
    incrementCDI(id) {
      var val = document.getElementById("qtyboxCDI_" + id).value;
      val = (Number(val) + 1);
      document.getElementById("qtyboxCDI_" + id).value = val;
      this.updateQty(val, id);
    },
    handleInputCDI(id){
      var val = Number(document.getElementById("qtyboxCDI_" + id).value);
      $("#qtyboxCDI_"+id).val(val);
      this.updateQty(val, id);
    },
    decrementCDI(id) {
      var val = document.getElementById("qtyboxCDI_" + id).value;
      if (val === 1) {
        console.log("Negative quantity not allowed");
      } else {
        val = (Number(val) - 1);
        document.getElementById("qtyboxCDI_" + id).value = val;
        this.updateQty(val, id);
      }
    },
    updateQty(val, id) {
      this.isLoading = true;
      this.$store.dispatch("updateCartQty", {
          val: val,
          id: id
        }).finally(() => {
          this.isLoading = false;
          this.loadCartItems(this.user.accountnumber);
        });
    },
    redirectCheckout() {
      this.$router.push("/shop/checkout");
    },
    Submit1Popup(evt) {
      evt.preventDefault();

      this.form1.cart = this.cart;
      this.form1.user_id = this.user.accountnumber;

      if(this.isPleated == true){
        this.form1.pc_type = "CDIP";
        this.form1.order_type = "CDI";
      }
      if(this.isQuickship == true){
          this.form1.pc_type = "CDIQ";
          this.form1.order_type = "CDI";
      }
      this.isLoading = true;
      this.$store
        .dispatch("AddProductToProject", {
          form: this.form1
        })
        .then(response => {
          if (response.data.success){
		        this.form1.error_name="";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
			      this.loadCartItems(this.user.accountnumber);
            this.form1 = new Form({
              client: null,
              project: null,
              cart: "",
              user_id: this.user.accountnumber,
			        error_name:'',
            });

            this.$refs["popupmodal"].hide();
            /*this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();*/
			
			
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });
			
			this.form1.error_name=response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit2Popup(evt) {
      evt.preventDefault();

      this.form2.cart = this.cart;
      this.form2.user_id = this.user.accountnumber;
      if(this.isPleated == true){
        this.form2.pc_type = "CDIP";
        this.form2.order_type = "CDI";
      }
      if(this.isQuickship == true){
        this.form2.pc_type = "CDIQ";
        this.form2.order_type = "CDI";
      }
      this.isLoading = true;
      this.$store
        .dispatch("AddProject", {
          form: this.form2
        })
        .then(response => {
          if (response.data.success) {
            this.form2.error_name='';
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
      
            this.loadCartItems(this.user.accountnumber);
			
            this.form2 = new Form({
              client_id: null,
              name: null,
              cart: "",
              user_id: this.user.accountnumber,
              error_name:'',
            });

            this.$refs["popupmodal"].hide();
            /*this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();*/
			
			
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });
      
            this.form2.error_name=response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit3Popup(evt) {
      evt.preventDefault();

      this.form.cart = this.cart;
      this.form.user_id = this.user.accountnumber;
      if(this.isPleated == true){
        this.form.pc_type = "CDIP";
        this.form.order_type = "CDI";
      }
      if(this.isQuickship == true){
        this.form.pc_type = "CDIQ";
        this.form.order_type = "CDI";
      }
      this.isLoading = true;
      this.$store
        .dispatch("AddClientAndProject", {
          form: this.form
        })
        .then(response => {
          if (response.data.success) {
            this.form.error_name='';
            //update clients dropdown
            this.LoadClients();

            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
            this.loadCartItems(this.user.accountnumber);
            this.form = new Form({
              createclient: null,
              createproject: null,
              cart: "",
              user_id: this.user.accountnumber,
			        error_name:'',
            });

            this.$refs["popupmodal"].hide();
            /*this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();*/
			
			
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });
			      this.form.error_name=response.data.error;
          }
        });
      this.isLoading = false;
    },
    Showsavetoproject(cur_cart) {
      console.log(cur_cart);
      this.resetModelForm();
      this.cart = cur_cart;
      this.$refs["popupmodal"].show();
    },
    showSavePromoToProject(cdi,pc_type) {
      if(pc_type == 'CDIP'){
        this.$refs.project.show(cdi,"1");
      }else if(pc_type == 'CDIQ'){
          this.$refs.project.show(cdi,"2");
      }else{
        this.$refs.project.show(cdi,"0");
      }
    },
    ShowsavetoprojectAll() {
      this.resetModelForm();
      this.cart = "all";
      if(this.inCartItems.ITEMS[0].PC_TYPE == 'CDIP'){
        this.isPleated = true;
      }
      if(this.inCartItems.ITEMS[0].PC_TYPE == 'CDIQ'){
        this.isQuickship = true;
      }
      this.$refs["popupmodal"].show();
    },
    resetModelForm() {
      $(".ordertype.type .error-msg").remove();
      $(".savetoclient .error-msg").remove();
	  
      $(".commonform .forstar").removeClass("haserror");
      $(".commonform .error-msg").html("");
	
      this.showclient = false;
      this.shownewproject = false;
      this.shownewclient = false;
      //reset forms
      this.cart = "";
      this.user_id = "";

      this.form.createclient = "";
      this.form.createproject = "";
      this.form.product_id = "";
      this.form.inventcolorid = "";
      this.form.pc_type = "";
      this.form.order_type = "";
      this.form.notes = "";
      this.form.quantity = "";
      this.form.user_id = "";
      this.form.cart = "";
	    this.form.error_name = "";

      this.form1.client = "";
      this.form1.project = "";
      this.form1.product_id = "";
      this.form1.inventcolorid = "";
      this.form1.pc_type = "";
      this.form1.order_type = "";
      this.form1.notes = "";
      this.form1.quantity = "";
      this.form1.user_id = "";
      this.form1.cart = "";
	    this.form1.error_name = "";

      this.form2.client_id = "";
      this.form2.name = "";
      this.form2.product_id = "";
      this.form2.inventcolorid = "";
      this.form2.pc_type = "";
      this.form2.order_type = "";
      this.form2.notes = "";
      this.form2.quantity = "";
      this.form2.user_id = "";
      this.form2.cart = "";
	    this.form2.error_name = "";
    },
    getProjects() {
      if (this.form1.client) {
        $(".showProject").show();
        this.$store
          .dispatch("LoadClientProjects", this.form1.client)
          .then(loadprojects => {
            this.projects = loadprojects.data;
          });
      } else {
        $(".showProject").hide();
      }
    },
    showProject1() {
      if (this.form2.client_id) {
        $(".showProject1").show();
      } else {
        $(".showProject1").hide();
      }
    },
    showProject2() {
      if (this.form.createclient) {
        $(".showProject2").show();
      } else {
        $(".showProject2").hide();
      }
    },
    LoadClients() {
      this.$store
        .dispatch("LoadClient", this.user.accountnumber)
        .then(loadclients => {
          this.clientscart = loadclients.data;
        });
    },
    loadDetailsCDI(id,arrkey){
      this.$refs.itemDetailCDI.show(this.inCartItems.CDIDATA[arrkey]);
    },
    loadBaseFabrics(product_id,itemid,inventcolorid){
      this.isLoadingBase = true;
      this.basestyleshow = true;
      this.$store.dispatch('getProductBaseFabrics', {
        itemId: itemid,
        inventColorId: inventcolorid,
      }).then(baseFabrics => {
        this.baseFabricsRegular = baseFabrics.data;
        this.baseFabrics = this.baseFabricsRegular;
        this.isLoadingBase = false;
        this.saveid = product_id;
      });
    },
    closeBaseFabrics() {
      this.basestyleshow = false;
    },
    baseFabricSelected(fabric) {
      this.basestyleshow = false;
      let mythis = this;
      this.isLoading = true;
      this.$store.dispatch("saveProductBaseFabricOnCart", {
        product_id: this.saveid,
        itemid:fabric.ITEMID,
        basefabric: fabric.NAME,
        basestyle: fabric.INVENTSTYLEID,
      }).then((saveproduct) => {
        this.isLoading = false;
        this.loadCartItems(this.user.accountnumber);
      });
    },
  }
};
</script>
<style>
.topcarthide {
  display: block;
}
.maincart {
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  width: 100%;
}
.maincart .leftcart {
  max-width: 945px;
  width: 63%;
  margin-left: auto;
}
.maincart .leftcart h1 {
  text-align: left;
  margin-top: 40px;
  margin-bottom: 40px;
}
.maincart .leftcart .singledetails {
  width: auto;
  position: relative;
  overflow: hidden;
  margin: 25px 0 0 0;
  padding-bottom: 0;
  padding-right: 75px;
  box-sizing: border-box;
}
.maincart .leftcart .singledetails .alldetails {
  width: 100%;
  border-bottom: 1px solid #d2d2d2;
  display: inline-block;
  padding-bottom: 30px;
}
.maincart .leftcart .singledetails:last-child .alldetails {
  border-bottom: 0;
  margin-bottom: 70px;
}
.maincart .leftcart .singledetails .alldetails .contentbox {
  position: relative;
  width: 81%;
  float: left;
  margin-left: 0;
}
.maincart .leftcart .singledetails .alldetails .imgbox {
  width: 19%;
  float: left;
}
.maincart .leftcart .singledetails .alldetails .imgbox img {
  width: 100%;
}
.maincart .leftcart .singledetails .alldetails .contentbox h3 {
  text-align: left;
  margin-bottom: 10px;
  margin-left: 15px;
  width: 84%;
  line-height: 24px;
}
.maincart .leftcart .singledetails .alldetails .contentbox h3 span.cartprice {
  position: absolute;
  right: 0;
  top: 0;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv {
  margin-bottom: 0;
  line-height: 20px;
  width: 100%;
  display: inline-block;
  margin-left: 15px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv span {
  margin-right: 5px;
  float: left;
  color: #777777;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv p {
  color: #303030;
  line-height: 20px;
  font-size: 14px;
  float: left;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv
  p.regularprice {
  float: left;
  text-decoration: line-through;
  margin-right: 10px;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv
  p.discountamt {
  float: left;
  width: auto;
  color: red;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv p.spe_inst {
  font-size: 14px;
  color: #777777;
  width: 60%;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv.quantity
  span,
.maincart .leftcart .singledetails .alldetails .contentbox .samediv.quantity p {
  margin-top: 5px;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv
  .qtydiv
  span {
  float: left;
  font-size: 18px;
  border: 1px solid #d2d2d2;
  margin: 0;
  height: 35px;
  line-height: 35px;
  padding: 0 8px;
  font-weight: 500;
  color: #303030;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  cursor: pointer;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv
  .qtydiv
  span.lastspan {
  -webkit-border-top-right-radius: 3px;
  -webkit-border-bottom-right-radius: 3px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomleft: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  line-height: 39px;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .samediv
  .qtydiv
  input {
  float: left;
  max-width: 45px;
  font-size: 14px;
  height: 35px;
  text-align: center;
  border-top: 1px solid #d2d2d2;
  border-bottom: 1px solid #d2d2d2;
  border-left: 0;
  border-right: 0;
  font-weight: 500;
  color: #303030;
  padding-top: 6px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv .notify_exceed{
  font-size: 10px;
  font-weight: normal;
  color: #ff0101;
  text-align: left;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv .editbaseproject{
  line-height: 20px;
  float: left;
  padding-left: 10px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .samediv .editbaseproject img{
  width: 15px;
  height: 15px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .savecancel {
  position: absolute;
  bottom: 0;
  right: 0;
}
.maincart .leftcart .singledetails .alldetails .contentbox .savecancel a {
  display: inline-block;
  margin-left: 20px;
  color: #303030;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #fff;
  padding-bottom: 3px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .savecancel img {
  height: 12px;
  width: 12px;
  margin-right: 5px;
  margin-top: -3px;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .savecancel
  .saveproj
  img {
  height: 15px;
  width: 15px;
}
.maincart .leftcart .singledetails .alldetails .contentbox .savecancel a:hover {
  border-bottom: 1px solid #303030;
  text-decoration: none;
}
.maincart
  .leftcart
  .singledetails
  .alldetails
  .contentbox
  .savecancel
  .deleteproj
  img {
  height: 13px;
  width: 13px;
}
.maincart .leftcart .singledetails .alldetails .specialint {
  width: 100%;
  float: right;
  margin-top: 10px;
}
.maincart .leftcart .singledetails .alldetails .specialint input {
  width: 100%;
  font-size: 14px;
  color: #777777;
  padding: 6.5px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: none;
  background: #fff;
  border: 1px solid #d2d2d2;
}
.maincart .rightcart {
  background: #ececec;
  padding: 75px 75px 75px 75px;
  box-sizing: border-box;
  width: 37%;
}
.maincart .rightcart .rightinner {
  width: 380px;
  padding-top: 75px;
}
.maincart .rightcart .rightinner .cartvalue {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0;
}
.maincart .rightcart .rightinner .cartvalue.totalvalue {
  /*background: #d2d2d2;*/
  padding: 10px 0 7px 0;
  box-sizing: border-box;
  border-radius: 3px;
  border-top:1px solid #d2d2d2;
  margin-top:20px;
}
.maincart .rightcart .rightinner .cartvalue span,
.maincart .rightcart .rightinner .cartvalue p {
  font-size: 14px;
  font-weight: 600;
  color: #303030;
  line-height: 28px;
}
.maincart .rightcart .rightinner button.btn.btn-dark {
  margin-top: 45px;
}
.maincart .rightcart .rightinner button.btn.btn-outline-primary {
  margin-top: 32px;
  margin-bottom: 45px;
}
.maincart .rightcart .rightinner .saveproject {
  height: 15px;
  width: 11px;
  margin: -3px 8px 0 0;
}
.maincart .rightcart .rightinner .saveproject.white {
  display: none;
}
.maincart
  .rightcart
  .rightinner
  button.btn.btn-outline-primary:hover
  .saveproject {
  display: none;
}
.maincart
  .rightcart
  .rightinner
  button.btn.btn-outline-primary:hover
  .saveproject.white {
  display: inline-block;
}
.maincart .rightcart .rightinner p.cartnote {
  color: #777777;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}
.maincart .rightcart .rightinner p.mt-45 {
  margin-top: 45px;
}
.maincart .rightcart .rightinner .help_signup {
  margin-top: 60px;
}
.maincart .rightcart .rightinner .help_signup p {
  font-size: 16px;
  font-weight: 500;
  color: #303030;
  text-align: center;
  margin-bottom: 30px;
}
.maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary {
  max-width: 150px;
  margin: 12px auto 0 auto;
  background: #fff;
}
.maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:hover {
  background: #303030;
  color:#fff;
}
.common_pop.delete_productcart .modal-dialog.modal-md {
  max-width: 490px;
}
.common_pop.delete_productcart .modal-dialog.modal-md h3 {
  margin-top: 20px;
}
.emptycart .noitems {
  max-width: 625px;
  display: block;
  margin: 35px auto 0 auto;
}
.emptycart .noitems .roundcart {
  height: 170px;
  width: 170px;
  border-radius: 50%;
  background: #303030;
  display: block;
  margin: 0 auto;
}
.emptycart .noitems .roundcart .cartimg {
  height: 80px;
  width: 80px;
  text-align: center;
  display: block;
  margin: 0px auto 0 auto;
  position: relative;
  top: 45px;
  right: 4px;
}
.emptycart .noitems h1 {
  margin: 30px 0 40px 0;
}
.emptycart .noitems ul.shopfromcart {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}
.emptycart .noitems ul.shopfromcart li {
  position: relative;
}
.emptycart .noitems ul.shopfromcart li a {
  color: #303030;
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 3px;
  border-bottom: 1px solid #fff;
}
.emptycart .noitems ul.shopfromcart li span {
  font-size: 14px;
  font-weight: 600;
  color: #303030;
  position: absolute;
  right: -30px;
  top: 2px;
}
.emptycart .noitems ul.shopfromcart li a:hover {
  text-decoration: none;
  border-bottom: 1px solid #303030;
}
.noitems .needhelp {
  padding: 35px;
  box-sizing: border-box;
  background: #ececec;
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom: 115px;
}
.noitems .needhelp h3 {
  text-align: left;
  margin-bottom: 30px;
}
.noitems .needhelp .callwrite {
  display: flex;
  justify-content: space-between;
}
.noitems .needhelp .callus h4,
.noitems .needhelp .writeus h4 {
  text-align: left;
  margin-bottom: 8px;
  font-weight: 600;
}
.noitems .needhelp a {
  font-size: 14px;
  line-height: 20px;
  margin-top: 12px;
  text-decoration: none;
  color: #303030;
  font-weight: normal;
  text-align: left;
  width: 100%;
}
.noitems .needhelp a:hover {
  text-decoration: none;
}
.noitems .needhelp a img {
  height: 14px;
  width: 14px;
  display: inline-block;
  margin: 0 10px 0 0;
}
.noitems .needhelp span {
  font-size: 12px;
  color: #777777;
  margin-top: 8px;
  display: inline-block;
  font-weight: normal;
}
@media only screen and (max-width: 1680px) and (min-width: 1541px) {
	.maincart .leftcart{max-width:905px;}
	.maincart .rightcart .rightinner{width:410px;}
}
@media only screen and (max-width: 1540px) and (min-width: 1441px) {
	.maincart .leftcart{max-width:890px;}
	.maincart .rightcart .rightinner{width:430px;}
}
@media only screen and (max-width: 1440px) {
  .maincart .leftcart {
    max-width: 795px;
	  width:57%;
  }
  .maincart .leftcart .singledetails .alldetails .contentbox .samediv p.spe_inst{
    width:50%;
  }
  .maincart .rightcart {
    padding: 75px 35px 75px 35px;
    width: 36%;
  }
}
@media only screen and (max-width: 1300px) {
  .maincart .leftcart {
    max-width: 775px;
    width: 60%;
  }
  .maincart .rightcart {
    padding: 75px 35px 75px 35px;
    width: 36%;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
  .maincart .leftcart h1 {
		margin-top: 20px;
		margin-bottom: 20px;
  }
  .topcarthide .maincart .leftcart{
    order:1;
  }
  .topcarthide .maincart .rightcart{
    order:2;
  }
	.maincart{
		flex-wrap:wrap;
		align-items:inherit;
	}
	.maincart .leftcart {
		max-width: 100%;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.maincart .rightcart {
		padding: 35px 20px 35px 20px;
		width: 100%;
	}
	.maincart .rightcart .rightinner{
		padding-top:0;
    padding-bottom:30px;
    max-width: 430px;
    margin: 0 auto;
	}
	.maincart .rightcart .rightinner button.btn.btn-dark {
		margin-top: 25px;
	}
	.maincart .rightcart .rightinner .help_signup {
		margin-top: 30px;
	}
	.maincart .rightcart .rightinner .help_signup p{
		margin-bottom:20px;
	}
	.maincart .leftcart .singledetails{
		padding-right:0;
	}
	.maincart .leftcart .singledetails:last-child .alldetails{
		margin-bottom:20px;
  }
  .maincart .leftcart .singledetails .alldetails .imgbox{
    width: 32%;
  }
  .maincart .leftcart .singledetails .alldetails .contentbox{
    width: 63%;
    margin-left: 30px;
  }
	.maincart .leftcart .singledetails .alldetails .contentbox .savecancel {
		position: relative;
		bottom: auto;
		right: auto;
		text-align: left;
		margin-top: 20px;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox .savecancel a{
		margin-left:0px;
    margin-right:10px;
	}
	.maincart .rightcart .rightinner{
		width:100%;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox h3,
	.maincart .leftcart .singledetails .alldetails .contentbox .samediv{
		margin-left:0;
	}
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
	.maincart .leftcart .singledetails .alldetails .imgbox {
		width: 25%;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox{
		width:70%;
	}
}
@media only screen and (max-width: 767px) {
	.maincart .leftcart h1 {
		margin-top: 20px;
		margin-bottom: 20px;
  }
  .topcarthide .maincart .leftcart{
    order:1;
  }
  .topcarthide .maincart .rightcart{
    order:2;
  }
	.maincart{
		flex-wrap:wrap;
		align-items:inherit;
	}
	.maincart .leftcart {
		max-width: 100%;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.maincart .rightcart {
		padding: 35px 20px 35px 20px;
		width: 100%;
	}
	.maincart .rightcart .rightinner{
		padding-top:0;
		padding-bottom:30px;
	}
	.maincart .rightcart .rightinner button.btn.btn-dark {
		margin-top: 25px;
	}
	.maincart .rightcart .rightinner .help_signup {
		margin-top: 30px;
	}
	.maincart .rightcart .rightinner .help_signup p{
		margin-bottom:20px;
	}
	.maincart .leftcart .singledetails{
		padding-right:0;
	}
	.maincart .leftcart .singledetails:last-child .alldetails{
		margin-bottom:20px;
	}
	.maincart .leftcart .singledetails .alldetails .imgbox {
		width: 100%;
		float: none;
		max-width: 240px;
		margin: 0 auto 20px auto;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox{
		width: 100%;
		float: none;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox .savecancel {
		position: relative;
		bottom: auto;
		right: auto;
		text-align: left;
		margin-top: 20px;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox .savecancel a{
		margin-left:0px;
    margin-right:10px;
	}
	.maincart .rightcart .rightinner{
		width:100%;
	}
	.maincart .leftcart .singledetails .alldetails .contentbox h3,
	.maincart .leftcart .singledetails .alldetails .contentbox .samediv{
		margin-left:0;
	}
}
</style>